import * as types from '../service/actionTypes';

export default function authState(state = {
                                        idToken: {},
                                        accessToken: {}
                                    },
                                    action) {
    switch (action.type) {
        case types.IDTOKEN:
            return {
                ...state,
                idToken: action.idToken
            }
        case types.ACCESSTOKEN:
            return {
                ...state,
                accessToken: action.accessToken
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js